module.exports = __webpack_public_path__ + "img/portraits_15_V.d500696d.webp";